import React from 'react';
import {Button, Stack} from "../ui";

interface IProps {
	files: Array<File>,
	onDeleted: {
		(file: File): void
	}
}

function PendingFileList({files, onDeleted}: IProps) {
	const getFileExtension = (file: File) => {
		return file.name.split('.').pop();
	}

	const handleClick = (file: File) => {
		onDeleted(file);
	}

	return (
		<Stack className="file-list justify-between items-center" direction="horizontal">
			<ul aria-label="Pending File List" className="list-none m-0 flex justify-start text-xl gap-2">
				{
					files.map((file: File, i: number) => (
						<li key={`${file.name}-${i}`}>
							<Button
								className="file fs-0 p-0 text-secondary deleting"
								title={file.name}
								onClick={() => handleClick(file)}
								variant="link">
								<i role="presentation"
								   className={`text-xl bi bi-file-earmark bi-filetype-${getFileExtension(file)}`}></i>
								{file.name}
							</Button>
						</li>
					))
				}
			</ul>
		</Stack>
	);
}

export default PendingFileList;
